import { Component, ChangeDetectionStrategy, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { SidenavLinkComponent } from "../sidenav-link/sidenav-link.component";
import { SidenavSection } from "../sidenav-nav.model";

/**
 * Renders one {@link SidenavSection}: an optional (expanded-only) subheading
 * plus a `<ul>` of `<li>`-wrapped {@link SidenavLinkComponent} links. Owns the
 * `<ul>/<li>` structure so list semantics stay valid.
 */
@Component({
    selector: "app-sidenav-section",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, SidenavLinkComponent],
    templateUrl: "./sidenav-section.component.html",
    styleUrl: "./sidenav-section.component.scss",
})
export class SidenavSectionComponent {

    // =========================================================================
    // INPUTS
    // =========================================================================
    public readonly section = input.required<SidenavSection>();
    public readonly expanded = input.required<boolean>();
}
